module.exports = __webpack_public_path__ + "media/images/mypage/icon/green/ico_message-b71c1548c2f263355c44615f4b36ff3c.svg";